import { connect } from 'react-redux';
import {
  getSensorAuthorizations,
  deleteSensorAuthorization,
  toggleSnackBar,
  getProjects,
  getBoards,
  updateProject,
  getDefaultIterations,
  toggleModal,
  DateSelectionChanged
} from 'state/callers';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';

import PMConfiguration from './PMConfiguration';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { hasIterationsSelector } from 'state/selectors/ui-state';

const mapStateToProps = state => {
  const { sensorAuthorizations, projects, boards } = state;
  return {
    sensorAuthorizations,
    projects,
    boards,
    isTeamLicense: isTeamLicenseSelector(state),
    license: licenseSelector(state),
    hasIterations: hasIterationsSelector(state)
  };
};

const mapDispatchToProps = {
  getSensorAuthorizations,
  toggleSnackBar,
  getBoards,
  getProjects,
  updateProject,
  deleteSensorAuthorization,
  getDefaultIterations,
  toggleModal,
  DateSelectionChanged
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(PMConfiguration, 'PMConfiguration'));
